<h3>{{ data().__typename }} => not yet existing</h3>
<pre class="data" [innerText]="dataJsonString()"></pre>
